(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gelblast-universe-portal"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gbu]').forEach((root) => {
    const quiz = root.querySelector('[data-quiz]');
    if (!quiz || quiz.dataset.ready === 'true') return;
    quiz.dataset.ready = 'true';
    const questions = [...quiz.querySelectorAll('[data-question]')];
    const results = [...quiz.querySelectorAll('[data-result]')];
    const reset = quiz.querySelector('[data-reset]');
    const update = () => {
      const selected = questions.map((question) => question.querySelector('[aria-pressed="true"]')).filter(Boolean);
      if (selected.length !== questions.length) return;
      const blaze = selected.filter((button) => button.dataset.team === 'blaze').length;
      const team = blaze >= 2 ? 'blaze' : 'nova';
      results.forEach((result) => { result.hidden = result.dataset.result !== team; });
      reset.hidden = false;
    };
    questions.forEach((question) => {
      question.querySelectorAll('button').forEach((button) => {
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => {
          question.querySelectorAll('button').forEach((choice) => choice.setAttribute('aria-pressed', 'false'));
          button.setAttribute('aria-pressed', 'true');
          update();
        });
      });
    });
    reset.addEventListener('click', () => {
      quiz.querySelectorAll('[aria-pressed]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
      results.forEach((result) => { result.hidden = true; });
      reset.hidden = true;
      questions[0].querySelector('button').focus();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
